import { Button, ButtonProps, ChakraComponent, forwardRef } from '@chakra-ui/react';
import { ElementsPackTypes } from 'modules/Editor/components/WidgetMenu/SideMenu/ElementsMenu/ElementsMenu.types';
import { useAppDispatch, useAppSelector } from 'modules/Editor/store';
import { selectActiveWidgetMenu, selectElementsWidgetMenuIndex } from 'modules/Editor/store/editorSettingsSelector';
import {
  setActiveElementWidgetMenu,
  setActiveWidgetMenu,
  setReplaceWidgetMenuIndex,
} from 'modules/Editor/store/editorSettingsSlice';
import { useTranslation } from 'react-i18next';
import { WIDGET_MENU_OPTIONS } from 'types/WidgetMenu.types';

export const ReplaceButton: ChakraComponent<typeof Button, ButtonProps> = forwardRef(function ReplaceMenuButton(
  inProps,
  ref,
) {
  const { onChange, initialTab, isElement, ...props } = inProps;

  const { t } = useTranslation('app');
  const label = t('button.replace');

  const dispatch = useAppDispatch();

  const activeWidgetMenu = useAppSelector(selectActiveWidgetMenu);
  const activeElementWidgetMenu = useAppSelector(selectElementsWidgetMenuIndex);
  let isReplaceMenuActive = activeWidgetMenu === WIDGET_MENU_OPTIONS.REPLACE;

  if (isElement) {
    isReplaceMenuActive =
      activeWidgetMenu === WIDGET_MENU_OPTIONS.ELEMENTS && activeElementWidgetMenu === ElementsPackTypes.GifsReplace;
  }

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    dispatch(setActiveWidgetMenu(WIDGET_MENU_OPTIONS.REPLACE));
    if (initialTab) dispatch(setReplaceWidgetMenuIndex(initialTab));
    inProps.onClick?.(e);
  };

  const handleClickElements = () => {
    if (isReplaceMenuActive) {
      dispatch(setActiveWidgetMenu(WIDGET_MENU_OPTIONS.NONE));
      dispatch(setActiveElementWidgetMenu(null));
      return;
    }
    if (activeWidgetMenu !== WIDGET_MENU_OPTIONS.ELEMENTS) {
      dispatch(setActiveWidgetMenu(WIDGET_MENU_OPTIONS.ELEMENTS));
    }
    dispatch(setActiveElementWidgetMenu(ElementsPackTypes.GifsReplace));
  };

  return (
    <Button
      ref={ref}
      size='sm'
      isActive={isReplaceMenuActive}
      onClick={isElement ? handleClickElements : handleClick}
      fontWeight='semibold'
      color={isReplaceMenuActive ? 'var(--vg-colors-blue-600)' : ''}
      variant='outline-with-active'
      {...props}
    >
      {label}
    </Button>
  );
});
